import { CommentsService } from 'sharebase/services/commentsService';
import { DeletedItemsServiceFactory } from 'sharebase/services/deletedItemsService';
import { DeploymentNameService } from 'sharebase/services/deploymentNameService';
import { DeploymentFactory } from 'sharebase/factories/deploymentFactory';
import { DocumentDetailServiceFactory } from 'sharebase/services/documentDetailService';
import { DocumentServiceFactory } from 'sharebase/services/documentService';
import { DirectoryNavigationServiceFactory } from 'sharebase/services/directoryNavigationService';
import { LibraryService } from 'sharebase/services/libraryService';
import { PinRepository } from 'sharebase/services/pinRepoService';
import { FolderUploadService} from 'sharebase/services/folderUploadService';
import { ShareServiceFactory } from 'sharebase/factories/shareService';	
import { ThemingService } from 'sharebase/services/themingService';
import { TrackableFavoritesService } from 'sharebase/services/favoritesService';
import { PendingActionsService } from 'sharebase/services/pendingActionsService';
import UsersService from './usersService';
import { UserService } from './userService';
import { DownloadService }  from  './downloadService';
import { FolderDetailServiceFactory } from './folderDetailService';
import { FolderServiceFactory } from './folderService';
import { NotificationsServiceFactory } from  './notificationService';
import { RecentDocumentsServiceFactory} from './recentDocumentsService';
import { SearchServiceFactory } from './searchService';
import { TagService } from './tagService';
import { UserGroupServiceFactory } from './userGroupService';
import { UserGroupsServiceFactory } from './userGroupsService';
import { SharedContentServiceFactory } from './sharedContentService';
import { FullTextSearchService } from './fullTextSearchService';
import { HelpBlurbFactoryFactory } from '../factories/helpBlurbFactory';
import { SubscriptionsService } from 'sharebase/services/subscriptionsService';
import { ContextMenuService } from 'sharebase/services/contextMenuService';
import { ActionRepository } from 'sharebase/services/actionRepository';
import { ToastService } from 'sharebase/services/toastService';
import { ToastMessageQueueService } from 'sharebase/services/toastMessageQueueService';
import { ValidatorPriority } from 'sharebase/domain';
import { 
	MenuItemFactory,
	MenuFactory,
	NotificationFactory,
	LibraryFactory
} from 'sharebase/factories';
import { TimeZonesFactory } from 'sharebase/services/timeZones';
import { TimeZoneService } from 'sharebase/services/timeZoneService';
import { MediaService } from './mediaService';
import { DesktopService } from './desktopService';
import { trackingModule } from './trackingService';
import { 
	TaskFactory, 
	FeatureToggleFactory 
} from 'sharebase/factories';
import { OfficeOnlineService } from './officeOnlineService';
import { UserGroupShareRightCollectionFactory } from 'sharebase/factories/userGroupShareRightCollectionFactory';

export const servicesModule = angular
	.module('sharebase.services',[
		'phoenix',
		'ngMaterial',
		'site.settings',
		'util.storage',
		'util.common',
		trackingModule.name,
		'gettext'
	])
	.factory('sbHelpBlurbFactory', HelpBlurbFactoryFactory)
	.service('sbLibraryFactory', LibraryFactory)
	.service('sbFullTextSearchService', FullTextSearchService)
	.service('sbFeatureToggleFactory', FeatureToggleFactory)
	.service('sbShareServiceFactory', ShareServiceFactory)
	.service('sbDeploymentFactory', DeploymentFactory)
	.service('sbDeploymentNameService', DeploymentNameService)
	.service('sbDownloadService', DownloadService)
	.factory('sbFolderService', FolderServiceFactory)
	.factory('sbFolderDetailService', FolderDetailServiceFactory)
	.service('sbPinRepo', PinRepository)
	.service('sbCommentsService', CommentsService)
	.service('sbFavoritesService', TrackableFavoritesService)
	.service('sbFolderUploadService', FolderUploadService)
	.service('sbPendingActionsService', PendingActionsService)
	.service('sbLibraryService', LibraryService)
	.service('sbUserService', UserService)
	.service('sbUsersService', UsersService)
	.factory('sbDeletedItemsService', DeletedItemsServiceFactory)
	.factory('sbDocumentDetailService', DocumentDetailServiceFactory)
	.factory('sbDocumentService', DocumentServiceFactory)
	.factory('sbDirectoryNavigationService', DirectoryNavigationServiceFactory)
	.service('sbThemingService', ThemingService)
	.factory('sbNotificationsService', NotificationsServiceFactory)
	.factory('sbRecentDocumentsService', RecentDocumentsServiceFactory)
	.factory('sbSearchService', SearchServiceFactory)
	.service('sbTagService', TagService)
	.factory('sbUserGroupService', UserGroupServiceFactory)
	.factory('sbUserGroupsService', UserGroupsServiceFactory)
	.service('sbSubscriptionsService', SubscriptionsService)
	.constant('SB_VALIDATOR_PRIORITY', ValidatorPriority)
	.service('sbMenuItemFactory', MenuItemFactory)
	.service('sbMenuFactory', MenuFactory)
	.service('sbActionRepository', ActionRepository)
	.service('sbContextMenuService', ContextMenuService)
	.service('sbToastMessageQueueService', ToastMessageQueueService)
	.service('sbToastService', ToastService)
	.factory('sbTimeZones', TimeZonesFactory)
	.service('sbTimeZoneService', TimeZoneService)
	.service('sbMediaService', MediaService)
	.factory('sbDesktopService', DesktopService.create)
	.factory('sbSharedContentService',	SharedContentServiceFactory)
	.service('sbNotificationFactory', NotificationFactory)
	.service('sbTaskFactory', TaskFactory)
	.service('sbOfficeOnlineService', OfficeOnlineService)
	.service('sbUserGroupShareRightCollectionFactory', UserGroupShareRightCollectionFactory);

export * from './documentService';
export * from './documentDetailService';
export * from './desktopService';
export * from './actionRepository';
export * from './contextMenuService';
export * from './deletedItemsService';
export * from './directoryNavigationService';
export * from './documentService';
export * from './downloadService';
export * from './folderService';
export * from './libraryService';
export * from './subscriptionsService';
export * from './toastService';
export * from './userGroupsService';
export * from './userService';
export * from './usersService';
export * from './folderUploadService';
export * from './trackingService';
export * from './favoritesService';
export * from './mediaService';
export * from './fullTextSearchService';
export * from './themingService';
export * from './deploymentNameService';
export * from './officeOnlineService';
export * from './tagService';


// WEBPACK FOOTER //
// ./src/sharebase/services/index.ts